import styled from 'styled-components';

export const Background = styled.div`
  padding: 20px;
  width: 100%;
`;

export const Container = styled.div`
  background-color: ${(props) => props.theme.newPalette.neutral.N200};
  display: flex;
  justify-content: space-between;
  ${(props) => props.theme.newTypography.textStyleBodySmall}
  color: ${(props) => props.theme.newPalette.neutral.N600};
  width: 100%;
  padding: 10px;
  border-radius: 10px;
`;

export const DetailsContainer = styled.div`
  display: flex;
  padding-bottom: 10px;
`;

export const IconContainer = styled.div`
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.theme.newPalette.neutral.N300};
  width: 40px;
  height: 40px;
  margin-right: 10px;
`;

export const Category = styled.div`
  ${(props) => props.theme.newTypography.textStyleBody}
  font-weight: bold;
  color: ${(props) => props.theme.newPalette.neutral.N900};
`;
